import React from "react";
import { Skeleton } from "@components/Skeleton/Skeleton";

export const ArchiveActionBarSkeleton: React.FC = () => (
  <>
    <div className="flex items-end justify-end gap-3 md:hidden">
      <Skeleton variant="circular" />
      <Skeleton variant="circular" />
    </div>
    <div className="hidden w-full justify-end gap-3 md:flex">
      <Skeleton variant="rounded" className="h-10 w-40" />
      <Skeleton variant="rounded" className="h-10 w-40" />
    </div>
  </>
);
